import { render } from "./TaskRelationship.vue?vue&type=template&id=019e439b&scoped=true"
import script from "./TaskRelationship.vue?vue&type=script&lang=js"
export * from "./TaskRelationship.vue?vue&type=script&lang=js"

import "./TaskRelationship.vue?vue&type=style&index=0&id=019e439b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019e439b"]])

export default __exports__